/**
 * @ Author: mzc
 * @ Create Time: 2024-07-04 10:12:28
 * @ Modified by: mzc
 * @ Modified time: 2024-07-12 19:41:41
 * @ Description: 全局状态管理
 */

import rechargeOrdersReducer from "./reducer/recharge-orders";
import shoppingCartReducer from "./reducer/shopping-cart";
import purchasingOrderListReducer from "./reducer/purchasing-order-list";
import purchasingOrderDetailReducer from "./reducer/purchasing-order-detail";
import procurementCenterReducer from "./reducer/procurement-center";
import procurementSelectGoodsReducer from "./reducer/procurement-select-goods";
import commonReducer from "./reducer/common";

import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { combineReducers } from "redux";
import { thunk } from "redux-thunk"; // 支持异步操作
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";

const reducer = combineReducers({
	commonReducer,
	rechargeOrdersReducer,
	shoppingCartReducer,
	purchasingOrderListReducer,
	purchasingOrderDetailReducer,
	procurementCenterReducer,
	procurementSelectGoodsReducer
});

const persistConfig = {
	key: "root",
	blacklist: [], // 黑名单不加入持久化
	storage
};

const persistedReducer = persistReducer(persistConfig, reducer);
const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

//暴露store
export { store, persistor };
